import { cn } from '@/lib/utils';
import { Logo } from '@/components/common/Logo';

export function PromotionPageLayout({
  children,
  step,
  totalSteps = 4,
  modal = false,
  modalSize = 'lg',
  showCollage = true,
  bgClass = null,
}) {
  const showProgress = typeof step === 'number';
  const progressPct = showProgress
    ? Math.min(100, Math.max(0, (step / totalSteps) * 100))
    : 0;

  const modalWidth = {
    sm: 'max-w-md',
    md: 'max-w-xl',
    lg: 'max-w-3xl',
    xl: 'max-w-4xl',
  }[modalSize];

  return (
    <div
      className={cn(
        'relative min-h-screen overflow-x-hidden',
        !showCollage && !bgClass && 'bg-linear-to-b from-brand-50/40 via-white to-white',
        bgClass
      )}
    >
      <div className="relative z-10">
        <header className="px-4 py-4 sm:px-6 sm:py-5">
          <Logo white={showCollage} className="h-9 sm:h-10" />
        </header>

        {showProgress && (
          <div className="px-4 pb-4 sm:px-6">
            <div className="mx-auto max-w-2xl">
              <div
                className={cn(
                  'h-2.5 w-full overflow-hidden rounded-full shadow-inner ring-1',
                  showCollage
                    ? 'bg-white/25 ring-white/10 backdrop-blur-sm'
                    : 'bg-slate-200 ring-slate-300/50'
                )}
              >
                <div
                  className="h-full rounded-full bg-brand-600 transition-all duration-700 ease-out"
                  style={{ width: `${progressPct}%` }}
                />
              </div>
            </div>
          </div>
        )}

        <main className={cn(modal ? 'pb-10 sm:pb-12' : 'pb-12')}>
          {modal ? (
            <div className="flex min-h-[calc(100vh-9rem)] items-start justify-center px-4 sm:px-6">
              <div
                role="dialog"
                aria-modal="true"
                className={cn(
                  'w-full overflow-hidden rounded-3xl bg-white shadow-2xl ring-1 ring-slate-900/10',
                  modalWidth
                )}
              >
                {children}
              </div>
            </div>
          ) : (
            children
          )}
        </main>
      </div>
    </div>
  );
}